import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { kbBrakeAppService } from 'src/app/services/feature/kb-brakeApplication/KbBrakeApplication.service';

@Component({
    selector: 'app-engg-review-popup',
    templateUrl: './engg-review-popup.component.html',
    styleUrls: ['../kb-brake-app-search-form.component.scss'],
    standalone: false
})
export class EnggReviewPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any,
    private router: Router,
    private service: kbBrakeAppService) {
  }

  newOne(code) {
    //have to go to form page
    this.service.engReview = false;

    this.service.isNewFormWithExistingValue = true;
    this.router.navigate(['bendixADBPage'], {
      queryParams: { code: code },
    });
  }
  review(code) {
    //have to go to form edit page  
    this.service.engReview = true;
    this.router.navigate(['bendixADBUpdatePage'], {
      queryParams: { code: code },
    });
  }
}
